import ContactForm from 'components/contacts/ContactForm'
import ContactsListItem from 'components/contacts/ContactsListItem'

import EntitiesList from 'components/entities/EntitiesList';
import dotProp from "dot-prop";
import { connect } from 'react-redux'

import { getContacts } from 'selectors/contacts'
import { Card } from 'semantic-ui-react'
import { createContactWithDefaults } from "../../actions/contacts";
import { fetchEntities } from "../../actions/entities";

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getContacts('list')(state),
    entityName: 'contact',
    item: ContactsListItem,
    form: ContactForm,
    listComponent: Card.Group,
    loading: state.meta.contact?.loading,
    error: state.meta.contact?.error,
    totalPages: dotProp.get(state, 'meta.contact.keyWindows.byWindow.list.totalPages'),
    activePage: dotProp.get(state, 'meta.contact.keyWindows.byWindow.list.page')
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchExtraEntities: () => {
      dispatch((dispatch, getState) => {
        let activePage = dotProp.get(getState(), 'meta.contact.keyWindows.byWindow.list.page')
        if(!activePage) dispatch(fetchEntities('contacts', { name: 'list', page: 1, append: true }))
      })
    },
    onLoadMore: (activePage, totalPages) => {
      if(activePage < totalPages) {
        dispatch(fetchEntities('contacts', { name: 'list', filter: {}, page: activePage + 1, append: true }))
      }
    },
    createEntityWithDefaults: () => {
      return dispatch(createContactWithDefaults())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList)
